// src/prompts/fragments/textOnlySurface.ts
var textOnlySurfacePrompt = [
  "Surface: text only.",
  '- This answer is delivered as PLAIN TEXT. There is no UI, no cards, no charts, and nothing is "shown above".',
  "- Any earlier instruction about the UI rendering results does NOT apply here \u2014 this overrides it.",
  "- Put the actual data in your text: the rows, names, dates and amounts the operator asked for.",
  '- Never say "shown above", "the card shows", "as displayed", or "click".',
  "- Keep it scannable \u2014 a short title line, one compact entry per row, then your read of it.",
  "- At most 10 rows. If there were more, say how many you left out."
].join("\n");

export {
  textOnlySurfacePrompt
};
